import { Component, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { ProfileService, SessionBackupService } from '../../services';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'lib-session-context-status-banner',
    templateUrl: './session-context-status-banner.component.html',
    styleUrls: ['./session-context-status-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionContextStatusBannerComponent {
  public userName = computed(() => `${this.profile()?.name} ${this.profile()?.lastName}` )
  public profile = toSignal(this.profileService.getCurrentProfile(), { initialValue: null });

  constructor(
    private readonly profileService: ProfileService,
    public readonly sessionBackupService: SessionBackupService) { }


  public switchBack(): void {
    this.sessionBackupService.restoreOriginalSession();
  }

  public clearOriginalSession(): void {
    this.sessionBackupService.clearOriginalSession();
  }
}
